import * as React from "react";
import { useEffect } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import TopNav from "components/top-nav";
import Footer from "components/footer";
import Navigation from "components/Navigation";
import { ColorModeSwitcher } from "ColorModeSwitcher";

const Layout = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // The home page carries its own navigation, so it skips the header and footer.
  return (
    <Flex direction="column" minH="100vh">
      {isHome ? (
        <Box position="absolute" top={4} right={4} zIndex={1}>
          <ColorModeSwitcher />
        </Box>
      ) : (
        <TopNav />
      )}
      <Box as="main" flex="1">
        <Navigation />
      </Box>
      {!isHome && <Footer />}
    </Flex>
  );
};

export default Layout;
